export const getSessionLengthCategory = (sessionLength: number) => {
  if (sessionLength < 12) {
    return "extra-short";
  }

  if (sessionLength < 16) {
    return "short";
  }

  if (sessionLength < 30) {
    return "medium";
  }

  return "long";
};
